module.exports = __webpack_public_path__ + "img/brackets-curly.0f8e844d.svg";